export { default } from './Popper';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Popper/index.js
// module id = 408
// module chunks = 2